import LoaderFullContent from './LoaderFullContent';

export default LoaderFullContent;
